module.exports = __webpack_public_path__ + "media/images/about_us/service-mobile-ff780dba1042a18c14042980ee780cca.jpg";